import React, { useMemo, useState, useEffect } from 'react';
import styles from './SubmitRoleplay.module.scss';
import { useLocation, useHistory } from 'react-router-dom';
import { imageBasePath } from 'constants';
import { useRoleplayStore } from 'features/roleplay/Roleplay.store';
import RoleplayHeader from '../Common/RoleplayHeader';
import { ProgressBar } from 'shared_ui_components';

const SubmitRoleplayHeader = () => {
  let location = useLocation();
  let history = useHistory();
  const roleplayView = useRoleplayStore((state) => state?.roleplayView);
  const [scenarios, setScenarios] = useState([]);
  const handleBack = () => {
    history.push({
      pathname: `/roleplay`,
      state: {
        prevPath: `${location.pathname}${location.search ? location.search : ''}`,
      },
    });
  }; // useMemo(() => first, [second])
  useEffect(() => {
    setScenarios(roleplayView?.scenarios || []);
  }, [roleplayView]);

  const scenariosCompleted = useMemo(
    () => scenarios.filter((item) => item.response && item.response.video).length,
    [scenarios]
  );

  return (
    <div className={styles.roleplayHeader}>
      <div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
          <button onClick={handleBack} className={styles.backBtn}>
            <img src={imageBasePath + 'back_arrow.svg'} alt="img" />
          </button>
          <p className="heading4">{roleplayView?.name || ''}</p>
        </div>
        <div>
          <span className={`${styles.value} heading6`}>
            {`${scenariosCompleted || 0}/${scenarios?.length || 0}`}{' '}
          </span>
          <span className="supportText" style={{ marginTop: 2 }}>
            Scenarios completed
          </span>
          <ProgressBar
            inProgress
            value={(scenariosCompleted * 100) / scenarios?.length}
            max={100}
            hideLabel={true}
          />
        </div>
      </div>

      <RoleplayHeader roleplayView={roleplayView} isForSubmitView />
    </div>
  );
};

export default SubmitRoleplayHeader;
